import { useDictionaryContext } from 'application/contexts/DictionaryContext';
import { ExampleBox } from 'designsystem/components/2-molecules/ExampleBox';
import { BackgroundContainerFeature } from 'features/Modules/BackgroundContainer';
import { generateId } from 'utilities/id';

export const ExampleBoxFeature: React.FC<Content.ExampleBox> = ({ content, settings, noBackground = false }) => {
	const { header, text } = content?.properties ?? {};
	const { enableFold, style } = settings?.properties ?? {};
	const dictionary = useDictionaryContext();
	const openText = dictionary.getAction('ReadMore');
	const closedText = dictionary.getAction('Close');

	return (
		<BackgroundContainerFeature enableBackground={!noBackground}>
			<ExampleBox
				id={generateId()}
				header={header}
				text={text?.markup}
				enableFold={enableFold}
				openText={openText}
				closedText={closedText}
				style={style}
			/>
		</BackgroundContainerFeature>
	);
};
